import { Component, HostListener, inject } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-formular-submit-failed-snack-bar',
    templateUrl: './formular-submit-failed-snack-bar.component.html',
    styleUrl: './formular-submit-failed-snack-bar.component.scss',
})
export class FormularSubmitFailedSnackBarComponent {
    private snackBarRef = inject(MatSnackBarRef);

    email = environment.FE.ffaSupportEMail;

    @HostListener('document:keydown.esc')
    closeSnackBar(): void {
        this.snackBarRef.dismiss();
    }
}
